export default __webpack_public_path__ + "static/media/cauldron.efca91d6.jpg";